import { render, staticRenderFns } from "./BetaChip.vue?vue&type=template&id=1f9fe7c5"
import script from "./BetaChip.vue?vue&type=script&lang=js"
export * from "./BetaChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports